import React from 'react'

const OperationGroup = () => {
  return (
    <div>Group</div>
  )
}

export default OperationGroup